/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description toBuildingUrl
 */

import { hyphenate } from '@zcode/utils'

import { APTS_BASE_URL, NZR_BLDG, NZR_BLDG_SEP } from '../../../settings'

import { getCleanBuildingName } from './getCleanBuildingName'
import { stripUnit } from './stripUnit'

export const toBuildingUrl = (
  buildingId: number,
  name?: string,
  address = '',
  city = '',
  state = '',
  hoodName?: string,
  zipcode = ''
) => {
  if (!name && !address && !city && !state && !hoodName && !zipcode) {
    return `${NZR_BLDG}/${buildingId}` as const
  }
  const buildingName = getCleanBuildingName(name ?? '')

  const aptsReg = new RegExp(`${APTS_BASE_URL}`, 'i')
  const separator = buildingName && aptsReg.test(buildingName) ? 'at' : NZR_BLDG_SEP
  const slug = hyphenate(
    buildingName,
    separator,
    address && stripUnit(address),
    city,
    state,
    zipcode
  )
  return `${NZR_BLDG}/${buildingId}/${slug}` as const
}
